/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppListCompositionsQueryResponse, WebAppListCompositionsQueryParams, WebAppListCompositions401, WebAppListCompositions403 } from "../models/WebAppListCompositions";

export function getWebAppListCompositionsUrl() {
  const res = { method: 'GET', url: `/web-app/v1/compositions` as const }
  return res
}

/**
 * @summary List compositions for a station (creator, edit previews; optional start/end on createdAt; optional name LIKE filter)
 * {@link /web-app/v1/compositions}
 */
export async function webAppListCompositions(params: WebAppListCompositionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppListCompositionsQueryResponse, ResponseErrorConfig<WebAppListCompositions401 | WebAppListCompositions403>, unknown>({ method : "GET", url : getWebAppListCompositionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}